import { ContentFieldType } from "../../../types/cms/contentField.type";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { parseToStringList } from "../internal/parseList";
import { resolvePath } from "../internal/resolvePath";
import { resolveConditionals } from "../internal/resolveConditionals";
import type { InterpolateParams } from "../types";

/**
 * Extrai `string[]` de um template single-token `{{path|array_string}}`
 * (ou `{{path|text}}` apontando para um valor array — caso legado para
 * templates gravados antes do mapeamento de `array_string` no
 * `getFieldTypeForPattern` da UI).
 *
 * Contrato estável: **sempre retorna `string[]`**. Caso o template não
 * case com a forma esperada, o tipo seja incompatível ou o valor não
 * seja conversível para lista, retorna `[]`.
 *
 * Aceita valores em duas formas:
 * - `unknown[]` — coerce cada item via `String(item)`.
 * - `string` com JSON válido representando array — parse seguro via
 *   `JSON.parse` em try/catch, depois coerce cada item.
 */
export function extractList({
  structure,
  template,
}: InterpolateParams): string[] {
  const match = resolveConditionals({ template, structure }).match(SINGLE_TOKEN_REGEX);
  if (!match) return [];

  const [, path, type] = match;
  if (
    type !== ContentFieldType.ARRAY_STRING &&
    type !== ContentFieldType.TEXT
  ) {
    return [];
  }

  const value = resolvePath(structure, path);
  return parseToStringList(value) ?? [];
}
